module.exports = __webpack_public_path__ + "img/parts-book-icon-nobg.12de9d28.svg";